import React, { useState, useEffect, useRef } from "react";
import { useGameContext } from '../GameContext';

import "./QuestionComponent.css";

import MultipleChoice from "./MultipleChoice";

import AudioRecorderComponent from "../Media/MediaComponent/AudioRecorderComponent";
import TakePhotoComponent from "../Media/MediaComponent/TakePhotoComponent";
import VideoRecorderComponent from "../Media/MediaComponent/VideoRecorderComponent";
import { MediaCaptureProvider } from "../context/MediaCaptureContext";
import uploadFile, { getFileType } from "../../utils/mediaUtils";

import { ANIMATIONS, RECORDING_LIMITS, RECORDING_MODE, SUBTITLE_RESTRICTION, TIMERS_GAME } from "../../utils/constants";
import Confetti from "react-confetti";

import { QuestionTypes } from "../../utils/types";
import icoCheck from '../../assets/ico-check.svg';

import correctSound from "../../assets/audios/IsCorrect.mp3";
import incorrectSound from "../../assets/audios/IsNotCorrect.mp3";
import popSound from "../../assets/audios/pop.mp3";
import celebrationSound from "../../assets/audios/Celebration.mp3";
import SyncedSubtitle from "../Subtitles/SyncedSubtitle";
import SubtitleRenderer from "../Subtitles/SubtitleRenderer";
import { getBorderColorByCardType } from "../../utils/styleUtils";
import QuestionTextContainer from "./QuestionTextContainer/QuestionTextContainer";
import Chronometer from "../in-game/chronometer/Chronometer";


/**
 * 
 * timeToReviewQuestions es usado para dejar N segundos de margen despues de que se acaba el tiempo para responder
 * asi durante esos N segundos el juego puede enviar la respuesta del usuario. 
 * y el usuario puede ver si su respuesta fue correcta o no.
 */
const timeToReviewQuestions = 5;

const randomFacts = [
  "Los humanos tenemos huellas en la lengua.",
  "El ojo de un avestruz es más grande que su cerebro.",
  "La nariz de los perros puede detectar hasta 100 mil millones de olores diferentes.",
  "Islandia crece 5 cm cada año debido a su ubicación sobre las placas tectónicas norteamericana y euroasiática.",
  "Los tiburones aparecieron 50 millones antes que los árboles, hace aproximadamente 400 millones de años.",
  "Si pudieras desdoblar el ADN humano, se extendería de aquí a Plutón y de regreso unas 17 veces.",
  "Según estudios, los humanos compartimos más del 50% de nuestro ADN con los plátanos."
];

const QuestionComponent = ({ playAnimation }) => {
  //  const [timeLeft, setTimeLeft] = useState(timer);
  const { user, game, socket, room } = useGameContext();


  const player = game.players.find(player => player.id === user);

  const [showConfetti, setShowConfetti] = useState(false);
  const [isSendData, setIsSendData] = useState(false);

  const [randomFact, setRandomFact] = useState(randomFacts[Math.floor(Math.random() * randomFacts.length)]);

  const videoRef = useRef();

  const currentAnswer = () => {
    if (player && player.answers) {
      return player.answers.find(answer => answer.question_id && answer.question_id === game.current_question.id);
    }
    return false;
  }

  const playSound = (isCorrect) => {
    const sound = new Audio(isCorrect ? correctSound : incorrectSound);
    sound.play();
  };

  const playSoundPop = () => {
    const sound = new Audio(popSound);
    sound.play();
  };

  const playSoundCelebration = () => {
    const sound = new Audio(celebrationSound);
    sound.playbackRate = 1.5;
    sound.play();
  };

  const [answer, setAnswer] = useState(currentAnswer() ? currentAnswer().answer : null);
  const [answerSubmitted, setAnswerSubmitted] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [labelFeedback, setLabelFeedback] = useState('¡Bien!');
  const [showFeedback, setShowFeedback] = useState(false);


  const handleConfirm = (answer) => {

    if (answer === null || answer === undefined || answer === "") {
      return;
    }

    setTimeout(() => {
      setLabelFeedback(game.current_question.feedbackFalsoVerdadero);
      setShowFeedback(true);
    }, 2000);

    playSoundPop();
    setAnswer(answer);
    setAnswerSubmitted(true);
    socket.emit("response_answer", { answer, gameKey: game.id, user });


    if (game.current_question.cardType !== QuestionTypes.CONOCIMIENTO) {
      setShowConfirmation(true); // Mostrar mensaje
      setIsSendData(true);
    } else {
      setRandomFact(randomFacts[Math.floor(Math.random() * randomFacts.length)]);
    }


  };

  const timePercentage = ((game.timeToStart - timeToReviewQuestions) / game.current_question.tiempoRespuesta) * 100; // Usar el timer inicial para calcular el porcentaje

  //the answer can only be updated if the user has not answered yet.
  const updateAnswer = (new_answer) => {
    if (!currentAnswer()) {
      setAnswer(new_answer);
    }
  }

  /* 
  when the game property is updated it is possible that a "time_up" counter
  is present on it. if it is and we don't have a current answer we must send the answer we currently have selected
  */
  let feedback = useRef(false);
  useEffect(() => {
    if (game.time_up > 0 && !currentAnswer() && answer) {
      socket.emit("response_answer", { answer, gameKey: game.id, user });
    }
    if (game.gameName.toLowerCase() === SUBTITLE_RESTRICTION.toLowerCase()) {
      setIsCCActive(localStorage.getItem("subtitles") === "true");
    }

    //si el jugador ya respondio y no hemos mostrado feedback
    if (currentAnswer() && feedback.current === false) {
      feedback.current = true;
      if (currentAnswer().correct) {
        playAnimation(ANIMATIONS.celebrating);
        playSoundCelebration();
        playSound(true); // Reproducir sonido correcto
      } else {
        playAnimation(ANIMATIONS.talking);
        if (game.current_question.cardType === "desafioConocimiento") {
          playSound(false); // Reproducir sonido incorrecto
        }

      }
    }

  }, [game]);

  const borderColor = game.current_question
    ? getBorderColorByCardType(game.current_question.cardType)
    : ''; // Fallback a color transparente si no es el último mensaje

  function Feedback() {

    if (!currentAnswer()) {
      return <></>;
    }

    if (currentAnswer().correct) {
      setShowConfetti(true);
      if (!showFeedback) {
        return <p className="feedback celebrate">{labelFeedback}</p>
      } else {
        if (game.current_question.esFalsoVerdadero == "true") {
          return !showFeedback ? (
            <p className="feedback">
              {(answer !== null && answer !== undefined && answer !== '' && answer !== 'no_answer') ?
                '¡A la próxima lo lograrás!' : '¡Ups! Se acabó el tiempo'}
            </p>
          ) : (

            <p className="feedback-alt"> {labelFeedback}</p>
          );
        } else {
          return (
            <p className="feedback-alt">
              La respuesta correcta era: {game.current_question.respuestas[game.current_question.respuestaCorrecta]}
            </p>
          );
        }
      }

    } else {
      if (game.current_question.cardType === "desafioConocimiento") {
        if (game.current_question.esFalsoVerdadero == "true") {
          return !showFeedback ? (
            <p className="feedback">
              {(answer !== null && answer !== undefined && answer !== '' && answer !== 'no_answer') ?
                '¡La próxima lo lograrás!' : 'Ups, se acabó el tiempo'}
            </p>
          ) : (

            <p className="feedback-alt"> {labelFeedback}</p>
          );
        } else {
          return (
            <p className="feedback-alt">
              La respuesta correcta era: <br /> {game.current_question.respuestas[game.current_question.respuestaCorrecta]}
            </p>
          );
        }

      } else {
        if (!showFeedback) {
          return <p className="feedback">{(answer !== null && answer !== undefined && answer !== '' && answer !== 'no_answer') ? '¡A la próxima lo lograrás!' : '¡Ups! No enviaste la evidencia'}</p>
        } else {
          return <p className="feedback-alt">{labelFeedback}</p>
        }
      }
    }
  }



  //if the question type is NOT a knowledge challenge, we must show the answer
  function showQuestion() {
    if (game.current_question.cardType !== "desafioConocimiento") {
      return true;
    }
    //si si es una pregunta de conocimiento 
    //si ya respondimos NO mostramos la pregunta
    if (currentAnswer()) {
      return false;
    }
    return true;
  }

  const [isCCActive, setIsCCActive] = useState(false);
  const [subtitle, setSubtitle] = useState('');
  const handleSubtitleChange = (text) => {
    if (isCCActive) {
      setSubtitle(text);
    }
  }

  return (

    <>
      {showConfetti && <Confetti />}
      <div className="question-container">

        {/**Si ya respondimos se muestra el dialogo de sam. */}
        {showQuestion() === false &&
          <div className="TextboxContainer" style={{
            borderColor, marginTop: game.current_question.cardType !== QuestionTypes.CONOCIMIENTO ? '2rem' : undefined,
          }}>
            <div className="TextboxBig">
              <Feedback />
            </div>
          </div>}

        {/** si no hemos respondido se muestra el contenido de la pregunta.  */}
        {showQuestion() &&
          <>
            <QuestionTextContainer
              text={game.current_question.challenge}
              style={{ borderColor }}
              displayHeader
              challengeType={game.current_question.cardType}
              rightHeaderContent={(game.timeToStart - TIMERS_GAME.timeToReviewQuestions) > 0 && <Chronometer time={game.timeToStart > 0 ? (game.timeToStart - TIMERS_GAME.timeToReviewQuestions) : 0} />}
            >
              {/* Mostrar solo la primera URL si existe */}
              {game.current_question.url && game.current_question.url.length > 0 && (
                <div className="media-gallery">
                  {(() => {
                    const mediaUrl = game.current_question.url[0];
                    const fileType = getFileType(mediaUrl);

                    if (fileType === "image") {
                      return <img src={mediaUrl} alt="Imagen de la pregunta" className="question-image" />;
                    } else if (fileType === "video") {
                      return (
                        <div className="flex items-center justify-center">
                          <SyncedSubtitle ref={videoRef} onCloseCaptionChange={handleSubtitleChange} />
                          <SubtitleRenderer text={subtitle} isActive={isCCActive} isAbsolute />
                          <video ref={videoRef} src={mediaUrl} autoPlay controls className="question-video" />
                        </div>
                      );
                    } else {
                      return <p className="unsupported-media">Tipo de archivo no soportado.</p>;
                    }
                  })()}
                </div>
              )}
            </QuestionTextContainer>
          </>
        }



        {game.current_question.cardType === QuestionTypes.CONOCIMIENTO && <MultipleChoice question={game.current_question} answer={answer} setAnswer={updateAnswer} />}

        {(game.current_question.cardType !== QuestionTypes.CONOCIMIENTO && game.current_question.tipoRespuesta === "audio") &&
          <MediaCaptureProvider defaultMediaUrl={answer || ""} mode={RECORDING_MODE.audio}>
            <AudioRecorderComponent timer={game.timeToStart - TIMERS_GAME.timeToReviewQuestions} submitDisabled={!!answer} onConfirmAudio={async (url, blob) => {
              const uploadedUrl = await uploadFile(blob, "audio-recording");
              if (!currentAnswer()) {
                handleConfirm(uploadedUrl); // Confirmar al subir el archivo
              }

            }} isSendData={isSendData} />
          </MediaCaptureProvider>}
        {(game.current_question.cardType !== QuestionTypes.CONOCIMIENTO && game.current_question.tipoRespuesta === "foto") &&
          <>
            <MediaCaptureProvider mode={RECORDING_MODE.photo} defaultMediaUrl={answer || ""}>
              <TakePhotoComponent timer={game.timeToStart - TIMERS_GAME.timeToReviewQuestions} submitDisabled={!!answer} onConfirmPhoto={async (url, blob) => {
                const uploadedUrl = await uploadFile(blob, "photo");
                if (!currentAnswer()) {
                  handleConfirm(uploadedUrl); // Confirmar al subir el archivo
                }
              }} isSendData={isSendData} />
            </MediaCaptureProvider>
          </>
        }
        {(game.current_question.cardType !== QuestionTypes.CONOCIMIENTO && game.current_question.tipoRespuesta === "video") &&
          <MediaCaptureProvider defaultMediaUrl={answer || ""}>
            <VideoRecorderComponent timer={game.timeToStart - TIMERS_GAME.timeToReviewQuestions} submitDisabled={!!answer} recordingLimit={RECORDING_LIMITS.video} onConfirmVideo={async (url, blob) => {
              const uploadedUrl = await uploadFile(blob, "video-recording");
              if (!currentAnswer()) {
                handleConfirm(uploadedUrl); // Confirmar al subir el archivo
              }
            }} isSendData={isSendData} />
          </MediaCaptureProvider>}

        {(game.current_question.cardType !== QuestionTypes.CONOCIMIENTO && game.current_question.tipoRespuesta === "texto") && (
          <div className="text-response-container">
            <textarea
              className="text-response-area"
              placeholder="Escribe tu respuesta aquí…"
              value={answer || ""}
              onChange={(e) => setAnswer(e.target.value)}
              disabled={currentAnswer()} // Deshabilitar si ya se respondió
            />
            <button className="ConfirmButton"
              onClick={() => handleConfirm(answer)}
              disabled={answer === null || currentAnswer()}>
              <div className="principalBtn">
                {showConfirmation || currentAnswer() ? 'Enviado' : 'Enviar'}
                {(showConfirmation || currentAnswer()) && <img className="sendCheck" src={icoCheck} alt="player ready" />}
              </div>
            </button>
          </div>
        )}


        {game.current_question.cardType === QuestionTypes.CONOCIMIENTO && (
          <button className="ConfirmButton"
            onClick={() => handleConfirm(answer)}
            disabled={currentAnswer() || answerSubmitted}>
            <div className="principalBtn">
              Enviar
            </div>
          </button>
        )}

        {(game.current_question.cardType === QuestionTypes.CONOCIMIENTO || game.current_question.cardType === QuestionTypes.CREATIVIDAD) &&
          <div className={`slide-up flex flex-col items-center w-full p ${answerSubmitted || currentAnswer() ? "slide-up-active" : ""}`}>
            <QuestionTextContainer
              text={`Se guardó tu respuesta. Mientras los demás responden, un dato curioso: ${randomFact}`}
            />
          </div>}
      </div></>
  );
};

export default QuestionComponent;